import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL || window.location.origin;

let socket = null;

export function useSocket(onEvent) {
  const ref = useRef(onEvent);
  ref.current = onEvent;

  useEffect(() => {
    if (!socket) {
      socket = io(SOCKET_URL);
      socket.emit('admin:join');
    }

    const handler = (event, data) => {
      if (ref.current) ref.current(event, data);
    };

    const events = [
      'session:started', 'session:ended', 'session:timer_expired',
      'machine:online', 'machine:offline', 'machine:screenshot', 'game:status', 'game:played',
      'machine:control:result', 'snack:order_created', 'snack:order_updated', 'booking:reminder'
    ];

    const listeners = new Map();
    events.forEach(e => {
      const listener = (data) => handler(e, data);
      listeners.set(e, listener);
      socket.on(e, listener);
    });

    return () => {
      listeners.forEach((listener, event) => socket.off(event, listener));
    };
  }, []);

  return socket;
}
